<ngx-skeleton-loader count="1" appearance="circle" [hidden]="!loading"
  [theme]="{ width: '4em', height: '4em', top: '0.25em'}">
</ngx-skeleton-loader>
<img [hidden]="loading" (load)="onLoad()" (error)="onError()" class="image-wrapper" [src]="getImage()" alt="placeholder">
